export default __webpack_public_path__ + "static/media/finance-pay-manual.6d729beb.svg";